import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FlowLayout from '../../../components/layout/FlowLayout';
import { selectConfigExpressTaxCertificateRequirements } from '../../../store/slices/config/configSelectors';
import { resetTaxCertState } from '../../../store/slices/taxCertificate/taxCertificateSlice';
import { FLOWS_ENUM } from '../../../common/enums';
import RequirementsList from '../../../components/common/RequirementsList';

const TaxCertRequirements = () => {
  const dispatch = useDispatch();
  const requirements = useSelector(
    selectConfigExpressTaxCertificateRequirements
  );

  useEffect(() => {
    dispatch(resetTaxCertState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBackClick = useCallback(() => {
    dispatch(resetTaxCertState());
  }, [dispatch]);

  return (
    <FlowLayout
      flow={FLOWS_ENUM.TAX_CERTIFICATE}
      title="Tax Certificate Requirements"
      onBack={handleBackClick}
      showBack
      showNext
    >
      <div className="mt-12 ml-0">
        <RequirementsList requirements={requirements} />
      </div>
    </FlowLayout>
  );
};

export default TaxCertRequirements;
